import styled from 'styled-components';
import { MangoBrightBlue, White } from '../../styles/colours';
import { DemiBold } from '../../styles/fonts';

export const DatePickerInputStyle = styled.div`
  .DateRangePickerInput input {
    cursor: pointer;
    text-align: center;
    font-size: 1rem;
  }

  .DateRangePickerInput input[id='startDate'] {
    border-right: 0;
  }

  .DateRangePickerInput input[id='endDate'] {
    border-left: 0;
  }

  .DateRangePickerInput .DateInput_input.DateInput_input__focused {
    font-family: ${DemiBold};
    border: none;
  }

  .DateRangePickerInput .DateRangePickerInput_arrow {
    line-height: 3.2;
  }

  .DateRangePickerInput__withBorder {
    background: transparent;
    border: none;
  }

  .DateRangePickerInput .DateRangePickerInput_arrow_svg,
  .DayPickerNavigation .DayPickerNavigation_button svg {
    fill: ${MangoBrightBlue};
  }

  .DateInput_fang .DateInput_fangStroke {
    stroke: ${White};
    fill: ${White};
  }
`;
